import HeadlineSecondary from './headline-secondary';
export default HeadlineSecondary;